import {Select} from "../ui/FormControls";
import { useEffect, useState } from "react";
import { type Backend } from "../api";
import { Dialog } from "../ui/Dialog";
import { handleSessionError } from "../session";

export function PermissionEditor({ backend, membershipId, displayName, onClose, onUnauthorized }: {
  backend: Backend; membershipId: string; displayName: string; onClose: () => void; onUnauthorized: () => void;
}) {
  const [catalog, setCatalog] = useState<string[]>([]);
  const [overrides, setOverrides] = useState<Record<string, "ALLOW" | "DENY">>({});
  const [error, setError] = useState("");
  const [busy, setBusy] = useState("");
  useEffect(() => {
    let active = true;
    Promise.all([backend.permissionCatalog!(), backend.permissionOverrides!(membershipId)]).then(([codes, values]) => {
      if (active) { setCatalog(codes); setOverrides(values); }
    }).catch(cause => { if (active && handleSessionError(cause, onUnauthorized) !== "unauthorized") setError("Не удалось загрузить права."); });
    return () => { active = false; };
  }, [backend, membershipId, onUnauthorized]);
  async function change(code: string, value: string) {
    setBusy(code); setError("");
    try {
      if (value === "INHERIT") await backend.clearPermissionOverride!(membershipId, code);
      else await backend.setPermissionOverride!(membershipId, code, value as "ALLOW" | "DENY");
      setOverrides(current => { const next = { ...current }; if (value === "INHERIT") delete next[code]; else next[code] = value as "ALLOW" | "DENY"; return next; });
    } catch (cause) { handleSessionError(cause, onUnauthorized); setError(`Не удалось изменить право ${code}.`); }
    finally { setBusy(""); }
  }
  return <Dialog open title={`Права: ${displayName}`} onClose={onClose}>
    <p>«По роли» наследует права назначенных ролей. «Разрешить» и «Запретить» задают персональное исключение.</p>
    {error && <p className="error" role="alert">{error}</p>}
    <div className="permission-list">{catalog.map(code => <label key={code}>{code}<Select value={overrides[code] ?? "INHERIT"} disabled={busy === code} onChange={event => void change(code, event.target.value)}><option value="INHERIT">По роли</option><option value="ALLOW">Разрешить</option><option value="DENY">Запретить</option></Select></label>)}</div>
    <div className="dialog-actions"><button className="button-secondary" type="button" onClick={onClose}>Закрыть</button></div>
  </Dialog>;
}
